import '../../assets/images/sliderBg.jpg';
import '../../assets/images/contactBg.jpg';
import '../../assets/images/sliderHeader.jpg';
